import { actionCreator } from "../../../Redux/rootReducer";
export const UPDATE_USER = actionCreator("update_user");
export const UPDATE_TOS = actionCreator("update_tos");
export const LOUGOUT = actionCreator("logout_user");